// @flow
export const theme = {
  color: {
    // 新規カラー (基本的にカラーはこちらを使用してください。)
    white: '#FFF',
    black: '#000',
    defaultBlack: '#343434',
    lineGray: '#DDD',
    selectionGray: '#F7F7F7',
    smokeWhite: '#f4f4f4',
    supplementaryLineGray: '#ECECEC',
    supplementaryTextGray: '#BDBDBD',
    textGray: '#939393',
    fundoorBlue: '#00A0E2',
    accentBlue: '#212B53',
    accentRed: '#E6230D',
    investorOrange: '#FB8B24',
    selectionBlue: '#F2F8FC',
    successGreen: '#2BA84A',
    stressGray: '#828282',

    // 既存カラー
    ripeLemon: '#f8e71c',
    lilyWhite: '#ecfaff',
    veryLightBlue: '#D7EEFF',
    mySin: '#fdba2c',
    paleBlue: '#d9edfd',
    grayLine: '#ffffff1f',
    lightSkyBlue: '#cde9ff',
    whiteBlue: '#AADCEE',
    skyBlue: '#46bafd',
    navy: '#002036',
    greyishFour: '#8ca0b4',
    greyishBrown: '#555555',
    greyishBrownFour: '#4a4a4a',
    doveGray: '#666666',
    grayIcon: '#b4bec8',
    grayOption: '#676767',
    pinkishGrey: '#bfbfbf',
    whiteThree: '#d2d2d2',
    whiteFive: '#d8d8d8',
    whiteSix: '#ededed',
    whiteGray: '#DEDEDE',
    grayTableInput: '#eef0f2',
    concrete: '#f2f2f2',
    grayPassword: '#eef0f2',
    grayLineBottom: '#e8e8e8',
    gray200: '#ececec',

    // その他カラー
    color54CEFC: '#54cefc',
    colorE2E6E8: '#e2e6e8',
    color0F57CA: '#0f57ca',
    colorEBEBEB: '#EBEBEB',
    colorE8F0F5: '#e8f0f5',
    colorF5F8FA: '#f5f8fa',
    color0F90BF: '#0f90bf',
  },
  screen: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};

export const { color, screen } = theme;
